module.exports = __webpack_public_path__ + "img/service_marketing.92bf43fd.jpg";